import React, { Component } from 'react';
import firebase from '../firebase.js';
import { Link, Redirect } from 'react-router-dom'

import DocumentForm from '../components/documentForm.js';

export default class DocumentNew extends Component {

  constructor () {
    super();
    this.state = {
      fireRedirect: false
    }
    this.addDocument = this.addDocument.bind(this);
  }

  addDocument(doc, e){
    e.preventDefault(); // <- prevent form submit from reloading the page
    const docRef = firebase.database().ref('documents');
    const id = docRef.child(this.props.user.uid).push({data: doc}).getKey();
    this.setState({ fireRedirect: `/document/${id}` })
  }

	render() {
    const { from } = this.props.location.state || '/'
    const { fireRedirect } = this.state

		return (
      <section className='display-item'>
        <h1>Uusi palvelusopimus</h1>
        <DocumentForm autoFill={{}} onSave={this.addDocument} />
        {fireRedirect && (
          <Redirect to={from || fireRedirect }/>
        )}
        <Link className="mdl-button mdl-button--raised mdl-button--accent navigation" to="/dashboard">Cancel</Link>
      </section>
		)

  }
}



// WEBPACK FOOTER //
// ./src/containers/documentNew.js